import React from 'react';
import BaseForm from 'components/newsletters/BaseForm';
import PropTypes from 'prop-types';
import Error from 'components/newsletters/shared/errors/landing/Error';
import Success from 'components/newsletters/shared/success/';
import SubscriptionLinks from 'components/newsletters/shared/messages/SubscriptionLinks';
import Button from 'components/shared/form/Button';
import Input from 'components/shared/form/Input';

class FooterForm extends BaseForm {
  defineInputClasses = () => {
    return this.state.errors ? 'input error' : 'input';
  };

  render() {
    const visibility = this.state.success ? 'none' : null;

    return (
      <form onSubmit={this.onSubmit.bind(this)} noValidate>
        <div className="col-xs-12">
          <p className="h4 font-size-xxs font-normal leading-text-tight padding-bottom-m no-margin">
            Unser Newsletter
          </p>
          <Input
            type="email"
            name="email"
            id={this.props.mainId}
            classes={this.defineInputClasses()}
            onChange={this.handleInputChange.bind(this)}
            value={this.state.email}
            style={{ display: visibility }}
          />
          {this.state.errors && <Error />}
          {this.state.success && (
            <Success
              containerName={this.props.container}
              isDoi={this.state.doi}
            />
          )}
        </div>
        <div
          className="col-xs-12 margin-top-m"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: this.state.success ? '0' : '24px',
          }}
        >
          <Button
            classes="light small"
            style={{ display: visibility }}
            value="Jetzt anmelden"
          />
          <SubscriptionLinks
            redesign={true}
            isSuccess={this.state.success}
            showLink={true}
            container={this.props.container}
            isDoi={this.state.doi}
          />
        </div>
        <div className="col-xs-12 margin-top-m">
          <p>
            Hier findest Du unsere{' '}
            <a
              className="display-inline"
              href="https://www.finanztip.schule/datenschutz/"
              target="_blank"
            >
              Datenschutzerklärung
            </a>
            .
          </p>
        </div>
      </form>
    );
  }
}

FooterForm.propTypes = {
  mainId: PropTypes.string.isRequired,
};

export default FooterForm;
